import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export const DEFAULT_AGREEMENT_STATUS = {
    in: [
        'active',
        'exhausted'
    ]
};
export const withDefaultAgreementStatus = (filter)=>filter.status == null ? _object_spread_props(_object_spread({}, filter), {
        status: DEFAULT_AGREEMENT_STATUS
    }) : filter;
